import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ride-fare-tooltip',
  templateUrl: './ride-fare-tooltip.component.html',
})
export class RideFareTooltipComponent implements OnInit {
  @Input() ride: any;
  show_rate_per_km = true;
  show_min_fare = true;
  constructor() { }

  ngOnInit() {
    if(this.ride.ride_km <= this.ride.minimum_fare_km){
      this.ride.base_fare = this.ride.minimum_fare;
      this.show_rate_per_km = false;
    }else{
      this.show_min_fare = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component/ride-fare-tooltip/ride-fare-tooltip.component.ts